export const getAppLocale = (): 'fa' | 'en' => import.meta.env.VITE_APP_LOCALE;
export const isAppLocaleFa = () => getAppLocale() === 'fa';
export const getAppBaseUrl = () => import.meta.env.VITE_BASE_URL;
export const getLandingBaseUrl = () => import.meta.env.VITE_LANDING_BASE_URL;
